import React, {Component} from 'react';
import './User.css';

class InActivateMemberModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			error: {},

		};
		this.cancelProcess = this.cancelProcess.bind(this);
		this.inActivate = this.inActivate.bind(this);
	}

	cancelProcess() {
		this.props.close();
	}

	inActivate() {
		this.props.inActivate();
		this.props.close();
	}

	render() {
		return (
			<div className='oda-form-container'>

				<div className='card-header'>
					<h4 className="card-title">
						{this.props.message}
					</h4>
				</div>
				<div className="modal-footer">
					<div className='col-sm-12 row' id="deleteModal">
						<div className='col-sm-2'>
							<button type="button" data-toggle="tooltip" data-placement="bottom"
									style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"150px"}}
									rel="tooltip" className="TekBtn vazgec "
									onClick={this.cancelProcess}>
								İptal
							</button>
						</div>
						<div className="col-sm-8"></div>
						<div className='col-sm-2'>
							<button type="button"
									data-toggle="tooltip"
									data-placement="bottom"
									style={{
										background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
										float: 'right', padding: '10px 54px 10px 23px', width:"150px"
									}}
									rel="tooltip" className="TekBtn kaydet"
									onClick={() => this.inActivate()}>Onayla
							</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default InActivateMemberModal;


// WEBPACK FOOTER //
// ./src/page/memberList/InActivateMemberModal.js